/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type RepInfoHeaderLoggedInStatusQueryVariables = {};
export type RepInfoHeaderLoggedInStatusQueryResponse = {
    readonly supportAppUser: {
        readonly id: string;
        readonly isLoggedInToCallcenterQueue: boolean | null;
    };
};
export type RepInfoHeaderLoggedInStatusQuery = {
    readonly response: RepInfoHeaderLoggedInStatusQueryResponse;
    readonly variables: RepInfoHeaderLoggedInStatusQueryVariables;
};



/*
query RepInfoHeaderLoggedInStatusQuery {
  supportAppUser {
    id
    isLoggedInToCallcenterQueue
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SupportAppUser",
    "kind": "LinkedField",
    "name": "supportAppUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isLoggedInToCallcenterQueue",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RepInfoHeaderLoggedInStatusQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RepInfoHeaderLoggedInStatusQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "9172b6eebe6b938885ce60c4e31a562d",
    "id": null,
    "metadata": {},
    "name": "RepInfoHeaderLoggedInStatusQuery",
    "operationKind": "query",
    "text": "query RepInfoHeaderLoggedInStatusQuery {\n  supportAppUser {\n    id\n    isLoggedInToCallcenterQueue\n  }\n}\n"
  }
};
})();
(node as any).hash = '18426bce3ffea15525176e63e3dabdc3';
export default node;
